'use client';

import Image from 'next/image';

interface AppImageProps {
  src: string;
  alt: string;
  className?: string;
}

export default function AppImage({ src, alt, className }: AppImageProps) {
  return (
    <Image data-component-id="src/components/ui/AppImage.tsx:13:4" data-component-path="src/components/ui/AppImage.tsx" data-component-line="13" data-component-end-line="19" data-component-file="AppImage.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%5Bvar%3Asrc%5D%22%2C%22alt%22%3A%22%5Bvar%3Aalt%5D%22%2C%22className%22%3A%22%5Bvar%3AclassName%5D%22%7D"
      src={src}
      alt={alt}
      className={className}
      width={600}
      height={400}
    />
  );
}
